const BASE_NAV_ACTION = 'NAVIGATION';

export const CLOSE_NAV = `${BASE_NAV_ACTION}/CLOSE_NAV`;
export const OPEN_NAV = `${BASE_NAV_ACTION}/OPEN_NAV`;
export const TOGGLE_NAV = `${BASE_NAV_ACTION}/TOGGLE_NAV`;
